module.exports = __webpack_public_path__ + "static/media/noCreditCard.3ec8fa04.png";